import React, { useState, useEffect } from 'react';
import Modal from "react-modal";

const StartTimeModal = ({ isOpen, onClose, onSave, currentTime, theme }) => {
    const [time, setTime] = useState('08:00');

    useEffect(() => {
        if (currentTime) {
            // Ensure we only use HH:MM format, strip seconds if present
            const timeHHMM = currentTime.substring(0, 5);
            setTime(timeHHMM);
        } else {
            setTime('08:00');
        }
    }, [currentTime, isOpen]);

    const handleSave = () => {
        if (time) {
            // Ensure we only send HH:MM format, strip seconds if present
            const timeHHMM = time.substring(0, 5); // Takes only HH:MM part
            
            if (/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeHHMM)) {
                onSave(timeHHMM);
                onClose();
            } else {
                alert('Please enter a valid time in HH:MM format');
            }
        } else {
            alert('Please enter a valid time in HH:MM format');
        }
    };

    const handleCancel = () => {
        setTime(currentTime || '08:00');
        onClose();
    };

    const modalStyles = {
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 1000,
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: theme === 'dark' ? '#222' : '#fff',
            color: theme === 'dark' ? '#fff' : '#000',
            border: theme === 'dark' ? '2px solid #555' : '2px solid #ccc',
            borderRadius: '8px',
            padding: '20px',
            width: '300px',
            maxWidth: '90vw',
        },
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleCancel}
            style={modalStyles}
            contentLabel="Set Start Time"
        >
            <div>
                <h3 style={{ marginTop: 0, marginBottom: '20px', textAlign: 'center' }}>
                    Set Driver Start Time
                </h3>
                
                <div style={{ marginBottom: '20px' }}>
                    <label 
                        htmlFor="start-time-input" 
                        style={{ 
                            display: 'block', 
                            marginBottom: '8px', 
                            fontWeight: 'bold' 
                        }}
                    >
                        Start Time:
                    </label>
                    <input
                        id="start-time-input"
                        type="time"
                        value={time}
                        onChange={(e) => {
                            // Ensure we only store HH:MM format, strip seconds if present
                            const timeValue = e.target.value.substring(0, 5);
                            setTime(timeValue);
                        }}
                        style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '4px',
                            border: theme === 'dark' ? '1px solid #555' : '1px solid #ccc',
                            backgroundColor: theme === 'dark' ? '#333' : '#fff',
                            color: theme === 'dark' ? '#fff' : '#000',
                            boxSizing: 'border-box',
                        }}
                        autoFocus
                    />
                </div>

                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    gap: '10px' 
                }}>
                    <button
                        onClick={handleCancel}
                        style={{
                            flex: 1,
                            padding: '10px 15px',
                            backgroundColor: theme === 'dark' ? '#555' : '#ccc',
                            color: theme === 'dark' ? '#fff' : '#000',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        style={{
                            flex: 1,
                            padding: '10px 15px',
                            backgroundColor: '#28a745',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                        }}
                    >
                        Save
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default StartTimeModal;